import React, { useState, useEffect } from 'react';
import {
  Box,
  Stepper,
  Step,
  StepLabel,
  Button,
  Typography,
  TextField,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Autocomplete,
  Chip,
  Divider,
  Card,
  CardContent,
  IconButton,
  Stack,
  Paper,
  Badge,
  selectClasses, Snackbar, Alert, alpha,
} from '@mui/material';
import {
  Add as AddIcon,
  Delete as DeleteIcon,
  ArrowBack as ArrowBackIcon,
  Close as CloseIcon,
  Groups as GroupsIcon,
  Assignment as AssignmentIcon,
  Edit as EditIcon,
  Schedule as ScheduleIcon,
  PriorityHigh as PriorityHighIcon,
  TaskAlt as TaskAltIcon
} from '@mui/icons-material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import axios from 'axios';
import { axiosInstance, localAxiosGet, localAxios, localAxiosToken } from '../../../Axios/axios';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import FlagIcon from '@mui/icons-material/Flag';
import EventIcon from '@mui/icons-material/Event';
import { set } from 'date-fns';

const getPriorityColor = (priority) => {
  switch (priority) {
    case 'High':
      return 'error';
    case 'Medium':
      return 'warning';
    case 'Low':
      return 'success';
    default:
      return 'default';
  }
};

const CreateTask = ({ onClose, projectData }) => {
  const [activeStep, setActiveStep] = useState(0);
  const [projects, setProjects] = useState([]);
  const [taskData, setTaskData] = useState({
    project: null,
    userStory: null,
    title: '',
    description: '',
    taskType: 'single',
    department: null,
    team: null,
    teamMembers: [],
    startDate: null,
    endDate: null,
    estimatedHours: null,
    estimatedMinutes: null,
    priority: 'Medium',
    subtasks: []
  });

  const [departments, setDepartments] = useState([]);
  const [teams, setTeams] = useState([]);
  const [teamMembers, setTeamMembers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentSubtask, setCurrentSubtask] = useState({
    title: '',
    description: '',
    assignees: [],
    startDate: null,
    endDate: null,
    estimatedHours: null,
    estimatedMinutes: null,
    priority: 'Medium'
  });
  const [editingIndex, setEditingIndex] = useState(null);
  const [showSubtaskForm, setShowSubtaskForm] = useState(true);

  const organizationId = localStorage.getItem('organizationId');
  const userId = localStorage.getItem('userId');
  const accessToken = localStorage.getItem('accessToken');
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success',
  })
  const handleSnackbarClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const formatDateForAPI = (date) => {
    if (!date) return null;
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
  useEffect(() => {
    fetchAllProjects();

  }, []);

  useEffect(() => {
    fetchAllDepartments();
  }, [taskData.project])

  const fetchAllProjects = async () => {

    try {
      const response = await axiosInstance(localAxiosGet(`/project/getAllProjectsBySupervisor/${userId}`, accessToken));
      if (response.data.status === 'SUCCESS') {
        setProjects(response.data.message.data)
      }
    } catch (error) {
      console.log('Error in fetching projects', error)
    }
  }

  const fetchAllDepartments = async () => {
    try {
      const response = await axiosInstance(localAxiosGet(`/project/getProjectById/${taskData.project.id}`, accessToken));
      if (response.data.status === 'SUCCESS') {
        setDepartments(response.data.message.data.departments);
      }
    } catch (error) {
      console.log('Error in fetching department', error)
    }
  }

  useEffect(() => {
    getTeamsForSelectedDepartment();
  }, [taskData.department, departments]);

  const getTeamsForSelectedDepartment = () => {
    if (taskData.department && departments.length > 0) {
      // Find the selected department object from the departments array
      const selectedDepartment = departments.find(
        (dep) => dep.department_id === taskData.department.department_id
      );

      console.log('seelctedDepartment', selectedDepartment)
      // If the department is found, set the teams state to its teams array
      if (selectedDepartment) {
        setTeams(selectedDepartment.teams);
        console.log('selected team', selectedDepartment.teams)
      } else {
        // If not found, clear the teams state
        setTeams([]);
        setTeamMembers([]);
      }
    } else {
      // If no department is selected, clear the teams state
      setTeams([]);
      setTeamMembers([]);
    }
  };

  useEffect(() => {
    getTeamMembersForSelectedTeam();
  }, [taskData.team]);

  const getTeamMembersForSelectedTeam = () => {
    // 1. Check if a team is selected and the 'teams' array is populated.
    if (taskData.team && teams.length > 0) {
      // 2. Find the selected team object from the 'teams' array.
      const selectedTeam = teams.find(
        (team) => team.team_id === taskData.team.team_id
      );

      // 3. Check if the team was found before setting the state.
      if (selectedTeam) {
        setTeamMembers(selectedTeam.members);
      } else {
        // 4. If no matching team is found, clear the team members list.
        setTeamMembers([]);
      }
    } else {
      // 5. If no team is selected, clear the team members list.
      setTeamMembers([]);
    }
  };

  const availableMembers = teamMembers.filter(
    (member) => !taskData.teamMembers.some((selected) => selected.id === member.id)
  );

  const validateStep = (step) => {
    switch (step) {     
   
      case 0: // Task Details
        if (!taskData.title.trim()) {
          setSnackbar({
            open: true,
            message: 'Please enter a task title',
            severity: 'error'
          });
          return false;
        }
        if (taskData.taskType === 'multiple') {
          if (!taskData.startDate || !taskData.endDate) {
            setSnackbar({
              open: true,
              message: 'Please select start and end dates for the main task',
              severity: 'error'
            });
            return false;
          }
        }
        return true;

      case 1: // Task Assignment / Subtasks
        if (taskData.taskType === 'single') {
          if (!taskData.department || !taskData.team) {
            setSnackbar({
              open: true,
              message: 'Please select department and team',
              severity: 'error'
            });
            return false;
          }
          if (taskData.teamMembers.length === 0) {
            setSnackbar({
              open: true,
              message: 'Please assign at least one team member',
              severity: 'error'
            });
            return false;
          }
          if (!taskData.startDate || !taskData.endDate) {
            setSnackbar({
              open: true,
              message: 'Please select start and end dates',
              severity: 'error'
            });
            return false;
          }
        } else {
          if (taskData.subtasks.length === 0) {
            setSnackbar({
              open: true,
              message: 'Please add at least one subtask',
              severity: 'error'
            });
            return false;
          }
        }
        return true;

      case 2:
        return true;

      default:
        return true;
    }
  };


  const handleNext = () => {
    if (!validateStep(activeStep)) {
      return;
    }
    setActiveStep((prevStep) => prevStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevStep) => prevStep - 1);
  };

  const handleInputChange = (field, value) => {
    setTaskData({ ...taskData, [field]: value });
  };

  const handleCurrentSubtaskChange = (field, value) => {
    setCurrentSubtask({ ...currentSubtask, [field]: value });
  };

  const resetSubtaskForm = () => {
    setCurrentSubtask({
      title: '',
      description: '',
      assignees: [],
      department: null,
      team: null,
      startDate: null,
      endDate: null,
      estimatedHours: null,
      estimatedMinutes: null,
      priority: 'Medium'
    });
    setEditingIndex(null);
  };

  const addOrUpdateSubtask = () => {
    // Validate required fields
    if (!currentSubtask.title || !currentSubtask.title.trim()) {
      setSnackbar({
        open: true,
        message: 'Please enter a task title',
        severity: 'error'
      });
      return;
    }

    if (!taskData.department) {
      setSnackbar({
        open: true,
        message: 'Please select a department',
        severity: 'error'
      });
      return;
    }

    if (!taskData.team) {
      setSnackbar({
        open: true,
        message: 'Please select a team',
        severity: 'error'
      });
      return;
    }

    if (!currentSubtask.startDate || !currentSubtask.endDate) {
      setSnackbar({
        open: true,
        message: 'Please select start and end dates',
        severity: 'error'
      });
      return;
    }

    const newSubtask = {
      ...currentSubtask,
      title: currentSubtask.title.trim(),
      department: taskData.department,
      team: taskData.team,
      // Ensure estimated time defaults to 0 if not provided
      estimatedHours: currentSubtask.estimatedHours || 0,
      estimatedMinutes: currentSubtask.estimatedMinutes || 0
    };

    if (editingIndex !== null) {
      const updatedSubtasks = [...taskData.subtasks];
      updatedSubtasks[editingIndex] = newSubtask;
      setTaskData({
        ...taskData,
        subtasks: updatedSubtasks
      });
    } else {
      setTaskData({
        ...taskData,
        subtasks: [...taskData.subtasks, newSubtask],
        // Reset department and team for the next subtask entry
        department: null,
        team: null
      });
    }

    resetSubtaskForm();
  };

  const editSubtask = (index) => {
    const subtask = taskData.subtasks[index];
    setCurrentSubtask(subtask);
    setEditingIndex(index);

    // Set department and team for editing
    setTaskData({
      ...taskData,
      department: subtask.department,
      team: subtask.team
    });

    // Show the form when editing
    setShowSubtaskForm(true);
  };

  const removeSubtask = (index) => {
    const updatedSubtasks = [...taskData.subtasks];
    updatedSubtasks.splice(index, 1);
    setTaskData({ ...taskData, subtasks: updatedSubtasks });
  };

  const handleCreateTask = async () => {
    setIsLoading(true);
    try {
      let taskPayload;

      if (taskData.taskType === 'single') {
        taskPayload = {
          task_type: "Single",
          project_id: taskData.project?.id,
          user_story_id: taskData.userStory?.id,
          manager_id: parseInt(userId),
          task_title: taskData.title,
          description: taskData.description,
          priority: taskData.priority,
          start_date: formatDateForAPI(taskData.startDate),
          due_date: formatDateForAPI(taskData.endDate),
          estimated_hours: taskData.estimatedHours + (taskData.estimatedMinutes / 60) || 0,
          department_id: taskData.department?.department_id,
          team_id: taskData.team?.team_id,
          assignees: taskData.teamMembers.map(member => member.id)
        };
      } else {
        // Multiple task payload - includes parent task details
        taskPayload = {
          task_type: "Multiple",
          project_id: taskData.project?.id,
          user_story_id: taskData.userStory?.id,
          manager_id: parseInt(userId),
          task_title: taskData.title,
          description: taskData.description,
          priority: taskData.priority,
          start_date: formatDateForAPI(taskData.startDate),
          due_date: formatDateForAPI(taskData.endDate),
          estimated_hours: taskData.estimatedHours + (taskData.estimatedMinutes / 60) || 0,
          department_id: taskData.department?.department_id,
          team_id: taskData.team?.team_id,
          assignees: taskData.teamMembers.map(member => member.id),
          subtasks: taskData.subtasks.map(subtask => ({
            task_title: subtask.title,
            description: subtask.description,
            priority: subtask.priority,
            start_date: formatDateForAPI(subtask.startDate),
            due_date: formatDateForAPI(subtask.endDate),
            estimated_hours: subtask.estimatedHours + (subtask.estimatedMinutes / 60) || 0,
            department_id: subtask.department?.department_id,
            team_id: subtask.team?.team_id,
            assignees: subtask.assignees.map(assignee => assignee.id)
          }))
        };
      }

      console.log('Task payload:', taskPayload);

      // Your API call here
      const response = await axiosInstance(localAxiosToken('/task/createTask', taskPayload));
      if (response.data.status === 'SUCCESS') {
        const createdTask = {
          id: response.data.message?.tasks.id || response.data.message.tasks
        };
        setSnackbar({
          open: true,
          message: response?.data?.message?.message,
          severity: 'success'
        });
        setTimeout(() => {
          setIsLoading(false);
          onClose(createdTask);
        }, 2000);
      } else {
        setSnackbar({
          open: true,
          message: response?.data?.message || 'Please check the fields and try again',
          severity: 'error'
        })
      }

    } catch (error) {
      console.error('Error creating task:', error);
      setSnackbar({
        open: true,
        message: error?.response?.data?.message || 'Error while creating the task. Please try again',
        severity: 'error'
      })
      setIsLoading(false);

    }
  };

  const steps = ['Project Selection', 'Task Details', taskData.taskType === 'single' ? 'Task Assignment' : 'Subtasks', 'Review'];

  const renderStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <Grid container spacing={1.5}>
            <Grid item xs={12}>
              <TextField
                label="Task Title"
                fullWidth
                required
                value={taskData.title}
                onChange={(e) => handleInputChange('title', e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Description"
                fullWidth
                multiline
                rows={2}
                value={taskData.description}
                onChange={(e) => handleInputChange('description', e.target.value)}
              />
            </Grid>

            {/* Task Type and Work Type in one row */}
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>Task Type</InputLabel>
                <Select
                  value={taskData.taskType}
                  label="Task Type"
                  onChange={(e) => {
                    const newTaskType = e.target.value;
                    setTaskData(prevData => ({
                      ...prevData,
                      taskType: newTaskType,
                      // Clear data specific to the other task type
                      ...(newTaskType === 'single' ? {
                        subtasks: [] // Clear subtasks when switching to single
                      } : {
                        department: null, // Clear single task assignment when switching to multiple
                        team: null,
                        teamMembers: [],
                        startDate: null,
                        endDate: null,
                        estimatedHours: null,
                        estimatedMinutes: null,
                        priority: 'Medium'
                      })
                    }));

                    // Also reset the current subtask form
                    if (newTaskType === 'multiple') {
                      resetSubtaskForm();
                    }
                  }}
                >
                  <MenuItem value="single">Single Task</MenuItem>
                  <MenuItem value="multiple">Multiple Tasks</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>Work Type</InputLabel>
                <Select
                  value={taskData.workType || 'Feature'}
                  label="Work Type"
                  onChange={(e) => handleInputChange('workType', e.target.value)}
                >
                  <MenuItem value="Bug">Bug</MenuItem>
                  <MenuItem value="Enhancement">Enhancement</MenuItem>
                  <MenuItem value="Feature">Feature</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            {/* Main Task Fields - Only show when task type is multiple */}
            {taskData.taskType === 'multiple' && (
              <>
                <Grid item xs={12} sm={6}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      label="Start Date"
                      value={taskData.startDate}
                      onChange={(date) => handleInputChange('startDate', date)}
                      slots={{
                        textField: TextField
                      }}
                      slotProps={{
                        textField: {
                          fullWidth: true
                        }
                      }}
                    />
                  </LocalizationProvider>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      label="End Date"
                      value={taskData.endDate}
                      onChange={(date) => handleInputChange('endDate', date)}
                      slots={{
                        textField: TextField
                      }}
                      slotProps={{
                        textField: {
                          fullWidth: true
                        }
                      }}
                      minDate={taskData.startDate}
                    />
                  </LocalizationProvider>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    label="Estimated Hours"
                    type="number"
                    fullWidth
                    value={taskData.estimatedHours}
                    onChange={(e) => handleInputChange('estimatedHours', parseInt(e.target.value) || 0)}
                    InputProps={{ inputProps: { min: 0 } }}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    label="Estimated Minutes"
                    type="number"
                    fullWidth
                    value={taskData.estimatedMinutes}
                    onChange={(e) => {
                      let value = parseInt(e.target.value) || 0;
                      if (value < 0) value = 0;
                      if (value > 59) {
                        value = 59;
                        setSnackbar({
                          open: true,
                          message: 'Minutes cannot exceed 59',
                          severity: 'warning'
                        });
                      }
                      handleInputChange('estimatedMinutes', value);
                    }}
                    InputProps={{ inputProps: { min: 0, max: 59 } }}
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <FormControl fullWidth>
                    <InputLabel>Priority</InputLabel>
                    <Select
                      value={taskData.priority}
                      label="Priority"
                      onChange={(e) => handleInputChange('priority', e.target.value)}
                    >
                      <MenuItem value="Low">Low</MenuItem>
                      <MenuItem value="Medium">Medium</MenuItem>
                      <MenuItem value="High">High</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </>
            )}
          </Grid>
        );
      case 1:
        if (taskData.taskType === 'single') {
          return (
            <Grid container spacing={1.5}>
              {/* Department and Team selection remains the same */}
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth required>
                  <InputLabel>Department</InputLabel>
                  <Select
                    value={taskData.department ? taskData.department.department_id : ''}
                    label="Department"
                    onChange={(event) => {
                      const selectedDepartment = departments.find(dept => dept.department_id === event.target.value);
                      setTaskData(prevData => ({
                        ...prevData,
                        department: selectedDepartment,
                        team: null,
                        teamMembers: [],
                      }));
                    }}
                  >
                    {departments.map((department) => (
                      <MenuItem key={department.department_id} value={department.department_id}>
                        {department.department_name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormControl fullWidth required>
                  <InputLabel id="team-select-label">Team</InputLabel>
                  <Select
                    labelId="team-select-label"
                    id="team-select"
                    value={taskData.team ? taskData.team.team_id : ''}
                    label="Team"
                    onChange={(event) => {
                      const selectedTeam = teams.find(team => team.team_id === event.target.value);
                      setTaskData(prevData => ({
                        ...prevData,
                        team: selectedTeam,
                        teamMembers: [],
                      }));
                    }}
                  >
                    {teams.map((team) => (
                      <MenuItem key={team.team_id} value={team.team_id}>
                        {team.team_name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              {/* Fixed Team Members Selection */}
              <Grid item xs={12}>
                <Autocomplete
                  multiple
                  options={teamMembers.filter(member =>
                    !taskData.teamMembers.some(selected => selected.id === member.id)
                  )}
                  getOptionLabel={(option) => `${option.first_name} ${option.last_name}`}
                  value={taskData.teamMembers}
                  onChange={(event, newValue) => {
                    handleInputChange('teamMembers', newValue);
                  }}
                  renderTags={(tagValue, getTagProps) =>
                    tagValue.map((option, index) => (
                      <Chip
                        label={`${option.first_name} ${option.last_name}`}
                        {...getTagProps({ index })}
                        key={option.id}
                        size="small"
                      />
                    ))
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Assign Team Members"
                      placeholder={taskData.teamMembers.length === 0 ? "Select team members" : ""}
                    />
                  )}
                  isOptionEqualToValue={(option, value) => option.id === value.id}
                  noOptionsText="No more members available"
                />
              </Grid>

              {/* Rest of the form remains the same */}
              <Grid item xs={12} sm={6}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    label="Start Date"
                    value={taskData.startDate}
                    onChange={(date) => handleInputChange('startDate', date)}
                    slots={{
                      textField: TextField
                    }}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        required: true
                      }
                    }}
                  />
                </LocalizationProvider>
              </Grid>

              <Grid item xs={12} sm={6}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    label="End Date"
                    value={taskData.endDate}
                    onChange={(date) => handleInputChange('endDate', date)}
                    slots={{
                      textField: TextField
                    }}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        required: true
                      }
                    }}
                    minDate={taskData.startDate}
                  />
                </LocalizationProvider>
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  label="Estimated Hours"
                  type="number"
                  fullWidth
                  value={taskData.estimatedHours}
                  onChange={(e) => handleInputChange('estimatedHours', parseInt(e.target.value) || 0)}
                  InputProps={{ inputProps: { min: 0 } }}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  label="Estimated Minutes"
                  type="number"
                  fullWidth
                  value={taskData.estimatedMinutes}
                  onChange={(e) => {
                    let value = parseInt(e.target.value) || 0;
                    if (value < 0) value = 0;
                    if (value > 59) {
                      value = 59;
                      setSnackbar({
                        open: true,
                        message: 'Minutes cannot exceed 59',
                        severity: 'warning'
                      });
                    }
                    handleInputChange('estimatedMinutes', value);
                  }}

                  InputProps={{ inputProps: { min: 0, max: 59 } }}
                />
              </Grid>

              <Grid item xs={12}>
                <FormControl fullWidth>
                  <InputLabel>Priority</InputLabel>
                  <Select
                    value={taskData.priority}
                    label="Priority"
                    onChange={(e) => handleInputChange('priority', e.target.value)}
                  >
                    <MenuItem value="Low">Low</MenuItem>
                    <MenuItem value="Medium">Medium</MenuItem>
                    <MenuItem value="High">High</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          );
        } else {
          return (
            <Grid container spacing={2}>
              {/* Left side - Task form OR Add button */}
              <Grid item xs={12} md={6}>
                <Paper elevation={2} sx={{ p: 3, borderRadius: 2 }}>
                  {showSubtaskForm ? (
                    // Show the form
                    <>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                        <GroupsIcon color="primary" sx={{ mr: 1 }} />
                        <Typography variant="h6">
                          {editingIndex !== null ? `Edit Task ${editingIndex + 1}` : 'Add New Task'}
                        </Typography>
                      </Box>

                      <Grid container spacing={1.5}>
                        {/* Department Selection */}
                        <Grid item xs={12}>
                          <FormControl fullWidth required>
                            <InputLabel>Department</InputLabel>
                            <Select
                              value={taskData.department ? taskData.department.department_id : ''}
                              label="Department"
                              onChange={(event) => {
                                const selectedDepartment = departments.find(dept => dept.department_id === event.target.value);
                                setTaskData(prevData => ({
                                  ...prevData,
                                  department: selectedDepartment,
                                  team: null,
                                  teamMembers: [],
                                }));
                                // Reset subtask assignees when department changes
                                setCurrentSubtask(prev => ({
                                  ...prev,
                                  assignees: [],
                                  team: null,
                                  department: selectedDepartment
                                }));
                              }}
                            >
                              {departments.map((department) => (
                                <MenuItem key={department.department_id} value={department.department_id}>
                                  {department.department_name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>

                        {/* Team Selection */}
                        <Grid item xs={12}>
                          <FormControl fullWidth required>
                            <InputLabel>Team</InputLabel>
                            <Select
                              value={taskData.team ? taskData.team.team_id : ''}
                              label="Team"
                              onChange={(event) => {
                                const selectedTeam = teams.find(team => team.team_id === event.target.value);
                                setTaskData(prevData => ({
                                  ...prevData,
                                  team: selectedTeam,
                                  teamMembers: [],
                                }));
                                // Reset subtask assignees when team changes
                                setCurrentSubtask(prev => ({
                                  ...prev,
                                  assignees: [],
                                  team: selectedTeam
                                }));
                              }}
                            >
                              {teams.map((team) => (
                                <MenuItem key={team.team_id} value={team.team_id}>
                                  {team.team_name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>

                        {/* Task Title */}
                        <Grid item xs={12}>
                          <TextField
                            label="Task Title"
                            fullWidth
                            required
                            value={currentSubtask.title}
                            onChange={(e) => handleCurrentSubtaskChange('title', e.target.value)}
                          />
                        </Grid>

                        {/* Task Description */}
                        <Grid item xs={12}>
                          <TextField
                            label="Task Description"
                            fullWidth
                            multiline
                            rows={3}
                            value={currentSubtask.description}
                            onChange={(e) => handleCurrentSubtaskChange('description', e.target.value)}
                          />
                        </Grid>

                        {/* Team Members */}
                        <Grid item xs={12}>
                          <Autocomplete
                            multiple
                            options={teamMembers.filter(member =>
                              !currentSubtask.assignees.some(selected => selected.id === member.id)
                            )}
                            getOptionLabel={(option) => `${option.first_name} ${option.last_name}`}
                            value={currentSubtask.assignees}
                            onChange={(event, newValue) => {
                              handleCurrentSubtaskChange('assignees', newValue);
                            }}
                            renderTags={(tagValue, getTagProps) =>
                              tagValue.map((option, index) => (
                                <Chip
                                  label={`${option.first_name} ${option.last_name}`}
                                  {...getTagProps({ index })}
                                  key={option.id}
                                  size="small"
                                />
                              ))
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Assign Team Members"
                                placeholder={currentSubtask.assignees.length === 0 ? "Select team members" : ""}
                              />
                            )}
                            isOptionEqualToValue={(option, value) => option.id === value.id}
                            noOptionsText="No more members available"
                          />
                        </Grid>
                        {/* Start Date */}
                        <Grid item xs={12} sm={6}>
                          <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker
                              label="Start Date"
                              value={currentSubtask.startDate}
                              onChange={(date) => handleCurrentSubtaskChange('startDate', date)}
                              slots={{
                                textField: TextField
                              }}
                              slotProps={{
                                textField: {
                                  fullWidth: true,
                                  required: true
                                }
                              }}
                            />
                          </LocalizationProvider>
                        </Grid>

                        {/* End Date */}
                        <Grid item xs={12} sm={6}>
                          <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker
                              label="End Date"
                              value={currentSubtask.endDate}
                              onChange={(date) => handleCurrentSubtaskChange('endDate', date)}
                              slots={{
                                textField: TextField
                              }}
                              slotProps={{
                                textField: {
                                  fullWidth: true,
                                  required: true
                                }
                              }}
                              minDate={currentSubtask.startDate}
                            />
                          </LocalizationProvider>
                        </Grid>

                        {/* Estimated Hours */}
                        <Grid item xs={12} sm={6}>
                          <TextField
                            label="Estimated Hours"
                            type="number"
                            fullWidth
                            value={currentSubtask.estimatedHours || ''}
                            onChange={(e) => handleCurrentSubtaskChange('estimatedHours', parseInt(e.target.value) || 0)}
                            InputProps={{ inputProps: { min: 0 } }}
                          />
                        </Grid>

                        {/* Estimated Minutes */}
                        <Grid item xs={12} sm={6}>
                          <TextField
                            label="Estimated Minutes"
                            type="number"
                            fullWidth
                            value={currentSubtask.estimatedMinutes || ''}
                            onChange={(e) => {
                              let value = parseInt(e.target.value) || 0;
                              if (value < 0) value = 0;
                              if (value > 59) {
                                value = 59;
                                setSnackbar({
                                  open: true,
                                  message: 'Minutes cannot exceed 59',
                                  severity: 'warning'
                                });
                              }
                              handleCurrentSubtaskChange('estimatedMinutes', value);
                            }}
                            InputProps={{ inputProps: { min: 0, max: 59 } }}
                          />
                        </Grid>

                        {/* Priority */}
                        <Grid item xs={12}>
                          <FormControl fullWidth>
                            <InputLabel>Priority</InputLabel>
                            <Select
                              value={currentSubtask.priority}
                              label="Priority"
                              onChange={(e) => handleCurrentSubtaskChange('priority', e.target.value)}
                            >
                              <MenuItem value="Low">Low</MenuItem>
                              <MenuItem value="Medium">Medium</MenuItem>
                              <MenuItem value="High">High</MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>

                        {/* Add/Update Button */}
                        <Grid item xs={12}>
                          <Button
                            variant="contained"
                            onClick={() => {
                              addOrUpdateSubtask();
                              setShowSubtaskForm(false);
                            }}
                            disabled={
                              !currentSubtask.title?.trim() ||
                              !taskData.department ||
                              !taskData.team ||
                              !currentSubtask.startDate ||
                              !currentSubtask.endDate
                            }
                            fullWidth
                            startIcon={<AddIcon />}
                            sx={{ mt: 2 }}
                          >
                            {editingIndex !== null ? 'Update Task' : 'Add Task'}
                          </Button>

                          {editingIndex !== null && (
                            <Button
                              variant="outlined"
                              onClick={() => {
                                resetSubtaskForm();
                                setShowSubtaskForm(false);
                              }}
                              fullWidth
                              sx={{ mt: 1 }}
                            >
                              Cancel Edit
                            </Button>
                          )}
                        </Grid>
                      </Grid>
                    </>
                  ) : (
                    // Show only "Add Another Subtask" button
                    <Box sx={{ textAlign: 'center', py: 8 }}>
                      <AssignmentIcon sx={{ fontSize: 48, mb: 2, color: 'primary.main' }} />
                      <Typography variant="h6" gutterBottom>
                        Ready to add another task?
                      </Typography>
                      <Button
                        variant="contained"
                        onClick={() => setShowSubtaskForm(true)}
                        startIcon={<AddIcon />}
                        size="large"
                      >
                        Add Another Subtask
                      </Button>
                    </Box>
                  )}
                </Paper>
              </Grid>

              {/* Right side - Added tasks list */}
              <Grid item xs={12} md={6}>
                <Paper elevation={2} sx={{ p: 3, borderRadius: 2, height: 'auto', mb: 2 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                    <Typography variant="h6">
                      Added Tasks
                    </Typography>
                    <Badge badgeContent={taskData.subtasks.length} color="primary" />
                  </Box>

                  {taskData.subtasks.length === 0 ? (
                    <Box sx={{ textAlign: 'center', py: 4, color: 'text.secondary' }}>
                      <AssignmentIcon sx={{ fontSize: 48, mb: 1, opacity: 0.5 }} />
                      <Typography>No tasks added yet</Typography>
                      <Typography variant="body2">Start by selecting a department and team</Typography>
                    </Box>
                  ) : (
                    <Stack spacing={1.5}>
                      {taskData.subtasks.map((subtask, index) => (
                        <Card key={index} variant="outlined" sx={{
                          borderLeft: `4px solid ${subtask.priority === 'High' ? '#f44336' :
                            subtask.priority === 'Medium' ? '#ff9800' : '#4caf50'
                            }`,
                          transition: 'all 0.2s',
                          '&:hover': {
                            boxShadow: 2,
                            transform: 'translateY(-2px)'
                          }
                        }}>
                          <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                            <Box display="flex" justifyContent="space-between" alignItems="flex-start">
                              <Box sx={{ flex: 1 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                  <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 600 }}>
                                    {subtask.title}
                                  </Typography>
                                  {/* Priority Chip */}
                                  {subtask.priority && (
                                    <Chip
                                      icon={<PriorityHighIcon />}
                                      label={subtask.priority}
                                      color={
                                        (() => {
                                          switch (subtask.priority) {
                                            case 'High':
                                              return 'error';
                                            case 'Medium':
                                              return 'warning';
                                            case 'Low':
                                              return 'primary';
                                            default:
                                              return 'default';
                                          }
                                        })()
                                      }
                                      variant="outlined"
                                      size="small"
                                    />
                                  )}
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                  <Chip
                                    label={subtask.department.department_name}
                                    size="small"
                                    variant="outlined"
                                    sx={{ mr: 1 }}
                                  />
                                  <Chip
                                    label={subtask.team.team_name}
                                    size="small"
                                    variant="outlined"
                                    color="primary"
                                  />
                                </Box>

                                <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1, mb: 1 }}>
                                  {/* Date Chip */}
                                  <Chip
                                    icon={<ScheduleIcon />}
                                    label={`${subtask.startDate ? subtask.startDate.toLocaleDateString() : 'N/A'} - ${subtask.endDate ? subtask.endDate.toLocaleDateString() : 'N/A'}`}
                                    variant="outlined"
                                    size="small"
                                  />
                                  <Chip
                                    label={`${subtask.estimatedHours || 0}h ${subtask.estimatedMinutes || 0}m`}
                                    variant="outlined"
                                    size="small"
                                  />
                                </Box>


                                {subtask.assignees.length > 0 && (
                                  <Box>
                                    <Typography variant="caption" color="textSecondary">
                                      Assignees:
                                    </Typography>
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: 0.5 }}>
                                      {subtask.assignees.slice(0, 3).map((assignee, i) => (
                                        <Chip
                                          label={`${assignee.first_name} ${assignee.last_name}`}
                                          size="small"
                                          sx={{ height: 20, fontSize: '0.7rem' }}
                                        />
                                      ))}
                                      {subtask.assignees.length > 3 && (
                                        <Chip
                                          label={`+${subtask.assignees.length - 3}`}
                                          size="small"
                                          sx={{ height: 20, fontSize: '0.7rem' }}
                                        />
                                      )}
                                    </Box>
                                  </Box>
                                )}
                              </Box>

                              <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                <IconButton
                                  onClick={() => editSubtask(index)}
                                  color="primary"
                                  size="small"
                                  sx={{ mb: 0.5 }}
                                >
                                  <EditIcon fontSize="small" />
                                </IconButton>
                                <IconButton
                                  onClick={() => removeSubtask(index)}
                                  color="error"
                                  size="small"
                                >
                                  <DeleteIcon fontSize="small" />
                                </IconButton>
                              </Box>
                            </Box>
                          </CardContent>
                        </Card>
                      ))}

                      {/* {taskData.subtasks.length > 0 && (
                        <Button
                          variant="outlined"
                          onClick={resetSubtaskForm}
                          startIcon={<AddIcon />}
                          fullWidth
                          sx={{ mt: 1 }}
                        >
                          Add Another Task
                        </Button>
                      )} */}
                    </Stack>
                  )}
                </Paper>
              </Grid>
            </Grid>
          );
        }
      case 2:
        return (
          <Box sx={{ mt: 3, p: 3, border: '1px solid #e0e0e0', borderRadius: 2, bgcolor: '#fafafa' }}>
            <Typography variant="h5" gutterBottom align="center" sx={{ color: '#333', mb: 4 }}>
              Task Overview
            </Typography>

            {/* Main Task Card */}
            <Card variant="outlined" sx={{ mb: 3, boxShadow: 3, borderRadius: 2 }}>
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column', flexWrap: 'wrap', gap: 1, mb: 2 }}>
                  <Typography variant="h6" sx={{ color: 'primary.main', fontWeight: 'bold' }}>
                    {taskData.title}
                  </Typography>
                  {taskData.project?.project_title && (
                    <Chip
                      label={`Project: ${taskData.project.project_title}`}
                      size="small"
                      color="primary"
                      variant="outlined"
                    />
                  )}
                  {taskData.userStory?.title && (
                    <Chip
                      label={`User Story: ${taskData.userStory.title}`}
                      size="small"
                      color="secondary"
                      variant="outlined"
                    />
                  )}
                  <Chip
                    label={`Type: ${taskData.taskType === 'single' ? 'Single Task' : 'Multiple Tasks'}`}
                    size="small"
                    color="secondary"
                    variant="outlined"
                  />
                </Box>

                {/* Show main task details for both single and multiple types */}
                <Grid container spacing={1.5} alignItems="flex-start">
                  <Grid item xs={12} sm={6} md={3}>
                    <Typography variant="caption" color="text.secondary" sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
                      <EventIcon fontSize="small" sx={{ mr: 0.5 }} />
                      Timeline
                    </Typography>
                    <Typography variant="body2">
                      {taskData.startDate?.toLocaleDateString() || 'N/A'} to {taskData.endDate?.toLocaleDateString() || 'N/A'}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <Typography variant="caption" color="text.secondary" sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
                      <AccessTimeIcon fontSize="small" sx={{ mr: 0.5 }} />
                      Estimated Time
                    </Typography>
                    <Typography variant="body2">
                      {taskData.estimatedHours || 0}h {taskData.estimatedMinutes || 0}m
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <Typography variant="caption" color="text.secondary" sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
                      <FlagIcon fontSize="small" sx={{ mr: 0.5 }} />
                      Priority
                    </Typography>
                    <Chip
                      label={taskData.priority}
                      color={getPriorityColor(taskData.priority)}
                      size="small"
                    />
                  </Grid>
                  {taskData.taskType === 'single' && (
                    <Grid item xs={12} sm={6} md={3}>
                      <Typography variant="caption" color="text.secondary" sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
                        <AssignmentIndIcon fontSize="small" sx={{ mr: 0.5 }} />
                        Assignees
                      </Typography>
                      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                        {taskData.teamMembers.map((member) => (
                          <Chip
                            key={member.id}
                            label={`${member.first_name} ${member.last_name}`}
                            size="small"
                            color="info"
                            variant="outlined"
                          />
                        ))}
                      </Box>
                    </Grid>
                  )}
                  <Grid item xs={12}>
                    <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 'bold' }}>
                      Description
                    </Typography>
                    <Typography variant="body2">
                      {taskData.description}
                    </Typography>
                  </Grid>
                  {taskData.userStory?.description && (
                    <Grid item xs={12}>
                      <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 'bold' }}>
                        User Story Description
                      </Typography>
                      <Typography variant="body2">
                        {taskData.userStory.description}
                      </Typography>
                    </Grid>
                  )}
                </Grid>
              </CardContent>
            </Card>

            {/* Subtask Details for Multiple Task Type */}
            {taskData.taskType === 'multiple' && (
              <>
                <Typography variant="h6" sx={{ mt: 4, mb: 2, color: 'secondary.main', fontWeight: 'bold' }}>
                  Subtasks
                </Typography>
                <Grid container spacing={1.5}>
                  {taskData.subtasks.map((subtask, index) => (
                    <Grid item xs={12} sm={6} key={index}>
                      <Card variant="outlined" sx={{ height: '100%', boxShadow: 2, borderRadius: 2 }}>
                        <CardContent>
                          <Box display="flex" justifyContent="space-between" alignItems="flex-start">
                            <Box sx={{ flex: 1 }}>
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 600 }}>
                                  {subtask.title}
                                </Typography>
                                {subtask.priority && (
                                  <Chip
                                    icon={<PriorityHighIcon />}
                                    label={subtask.priority}
                                    color={getPriorityColor(subtask.priority)}
                                    variant="outlined"
                                    size="small"
                                  />
                                )}
                              </Box>
                              <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, gap: 1 }}>
                                {subtask.department?.department_name && (
                                  <Chip
                                    label={subtask.department.department_name}
                                    size="small"
                                    variant="outlined"
                                  />
                                )}
                                {subtask.team?.team_name && (
                                  <Chip
                                    label={subtask.team.team_name}
                                    size="small"
                                    variant="outlined"
                                    color="primary"
                                  />
                                )}
                              </Box>

                              <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1, mb: 1 }}>
                                <Chip
                                  icon={<ScheduleIcon />}
                                  label={`${subtask.startDate ? subtask.startDate.toLocaleDateString() : 'N/A'} - ${subtask.endDate ? subtask.endDate.toLocaleDateString() : 'N/A'}`}
                                  variant="outlined"
                                  size="small"
                                />
                                {/* In the review section */}
                                <Chip
                                  icon={<AccessTimeIcon />}
                                  label={`${subtask.estimatedHours || 0}h ${subtask.estimatedMinutes || 0}m`}
                                  variant="outlined"
                                  size="small"
                                />
                              </Box>

                              {subtask.assignees.length > 0 && (
                                <Box>
                                  <Typography variant="caption" color="textSecondary">
                                    Assignees:
                                  </Typography>
                                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: 0.5 }}>
                                    {subtask.assignees.slice(0, 3).map((assignee, i) => (
                                      <Chip
                                        key={i}
                                        label={`${assignee.first_name} ${assignee.last_name}`}
                                        size="small"
                                        sx={{ height: 20, fontSize: '0.7rem' }}
                                      />
                                    ))}
                                    {subtask.assignees.length > 3 && (
                                      <Chip
                                        label={`+${subtask.assignees.length - 3}`}
                                        size="small"
                                        sx={{ height: 20, fontSize: '0.7rem' }}
                                      />
                                    )}
                                  </Box>
                                </Box>
                              )}
                              <Box sx={{ mt: 2 }}>
                                <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 'bold' }}>
                                  Description
                                </Typography>
                                <Typography variant="body2">
                                  {subtask.description}
                                </Typography>
                              </Box>
                            </Box>
                          </Box>
                        </CardContent>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              </>
            )}
          </Box>
        );
      default:
        return <Typography>Unknown step</Typography>;
    }
  };

  return (
    <Card
      sx={{
        borderRadius: 2,
        boxShadow: '0 1px 20px rgba(0,0,0,0.08)',
        border: '1px solid',
        borderColor: alpha('#10b981', 0.15),
        overflow: 'hidden'
      }}
    >
      {/* Header */}
      <Box
        sx={{
          background: `linear-gradient(135deg, ${alpha('#10b981', 0.1)} 0%, ${alpha('#059669', 0.1)} 100%)`,
          borderBottom: '1px solid',
          borderBottomColor: alpha('#10b981', 0.1),
          p: 1.5,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Box sx={{
            p: 0.5,
            borderRadius: 1.5,
            backgroundColor: alpha('#10b981', 0.1),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <TaskAltIcon sx={{ color: '#10b981', fontSize: 20 }} />
          </Box>
          <Box>
            <Typography variant="h6" sx={{ color: '#1e293b', fontWeight: 600 }}>
              Create Task
            </Typography>
            {projectData && (
              <Typography variant="caption" sx={{ color: '#64748b', fontSize: '0.75rem' }}>
                Project: {projectData.project_title}
              </Typography>
            )}
          </Box>
        </Box>

        <IconButton
          onClick={onClose}
          size="small"
          sx={{
            color: '#64748b',
            '&:hover': {
              backgroundColor: alpha('#64748b', 0.1)
            }
          }}
        >
          <CloseIcon />
        </IconButton>
      </Box>

      <Box sx={{ mt: 2, mb: 4, px: 4, pt: 2 }}>
        <Stepper activeStep={activeStep}>
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
      </Box>

      <Box sx={{ mb: 4, px: 4, }}>
        {renderStepContent(activeStep)}
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'space-between', px: 4, pb: 4, }}>
        <Button
          onClick={activeStep === 0 ? onClose : handleBack}
          startIcon={activeStep === 0 ? null : <ArrowBackIcon />}
          variant="outlined"
          sx={{
            borderRadius: '8px',
            textTransform: 'none',
            borderColor: '#94a3b8',
            color: '#94a3b8',
            px: 4,
            '&:hover': {
              borderColor: '#64748b',
              backgroundColor: 'transparent'
            }
          }}
        >
          {activeStep === 0 ? 'Cancel' : 'Back'}
        </Button>
        <Button
          variant="contained"
          onClick={activeStep === steps.length - 1 ? handleCreateTask : handleNext}
          disabled={isLoading || (activeStep === 2 && taskData.taskType === 'multiple' && taskData.subtasks.length === 0)}
          sx={{
            borderRadius: '8px',
            textTransform: 'none',
            background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
            px: 4,
            '&:hover': {
              background: 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)'
            }
          }}
        >
          {isLoading ? 'Processing...' : activeStep === steps.length - 1 ? 'Create Task' : 'Next'}
        </Button>
      </Box>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'center', horizontal: 'center' }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.severity}
          sx={{ width: '100%' }}
          variant="filled"
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Card>
  );
};

export default CreateTask;